module.exports = __webpack_public_path__ + "static/media/msap-push-notifications.fec430b4.png";